module.exports = __webpack_public_path__ + "img/Publisher Icon.bdb6cb88.svg";